import "./header.comp.scss";
import { Link, useLocation } from "react-router-dom";
import React, { useContext, useState } from "react";
import { LanguageContext } from "../../contexts/language/language.context";
import {} from "@mui/icons-material";
import enFlag from "../../assets/emojis/flags/en-flag.png";
import frFlag from "../../assets/emojis/flags/fr-flag.png";
import { useResponsive } from "../../hooks/responsive.hook";
import { Drawer, Icon } from "@mui/material";
import MenuSharpIcon from "@mui/icons-material/MenuSharp";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
const cv = require("../../assets/files/CV-fenohasina-jean-felicien-brillant.pdf");

const downloadCV = () => {
  const a = document.createElement("a");
  a.href = cv;
  a.download = "cv-brillant.pdf";
  a.click();
};

const Header = () => {
  const { l, changeLanguage } = useContext(LanguageContext);
  const location = useLocation();
  const { currentScreen } = useResponsive();

  const Links = () => (
    <>
      <Link
        className={`link ${
          location.pathname === "/about-me" ? "activated" : ""
        }`}
        to="/about-me"
      >
        {l.header.aboutMe}
      </Link>
      <Link
        className={`link ${location.pathname === "/skills" ? "activated" : ""}`}
        to="/skills"
      >
        {l.header.skills}
      </Link>
      {/* <Link
        className={`link ${
          location.pathname === "/experiences" ? "activated" : ""
        }`}
        to="/experiences"
      >
        {l.header.experiences}
      </Link> */}
      <Link
        className={`link ${
          location.pathname === "/projects" ? "activated" : ""
        }`}
        to="/projects"
      >
        {l.header.projects}
      </Link>
      <Link
        className={`link ${
          location.pathname === "/contact" ? "activated" : ""
        }`}
        to="/contact"
      >
        {l.header.contact}
      </Link>
      {/* <Link
        className={`link ${location.pathname === "/review" ? "activated" : ""}`}
        to="/review"
      >
        {l.header.review}
      </Link> */}

      {currentScreen.size === "small" &&
        currentScreen.orientation === "portrait" && (
          <aside className="menu-cv-download-btn" onClick={downloadCV}>
            <FileDownloadOutlinedIcon className="download-icon" />
            <p>{l.header.download}</p>
          </aside>
        )}
    </>
  );

  const MySideNav = () => {
    const [drawerState, toggleDrawer] = useState(false);
    return (
      <>
        <MenuSharpIcon
          fontSize="large"
          sx={{ color: "dodgerblue", cursor: "pointer" }}
          onClick={() => toggleDrawer(true)}
        />
        <Drawer
          className="header-drawer"
          open={drawerState}
          onClose={() => toggleDrawer(false)}
        >
          <ArrowBackSharpIcon
            fontSize="large"
            className="header-drawer-close-btn"
            onClick={() => toggleDrawer(false)}
          />
          <Links />
        </Drawer>

        <h1>{getHeaderTitle(location.pathname, l.header)}</h1>
      </>
    );
  };

  return (
    <nav className="header-container">
      {currentScreen.size !== "small" ||
      currentScreen.orientation === "landscape" ? (
        <Links />
      ) : (
        <MySideNav />
      )}

      <div className="language-field">
        <div className="language-flag">
          <img alt="image" src={getFlag(l.code)} />
        </div>
        <select
          name="language"
          value={l.code}
          id="language"
          onChange={(e) => changeLanguage(e.target.value as "en" | "fr")}
        >
          <option value="en">English</option>
          <option value="fr">Français</option>
        </select>
      </div>
    </nav>
  );
};

export default Header;

function getFlag(code: "en" | "fr") {
  switch (code) {
    case "fr":
      return frFlag;
    default:
      return enFlag;
  }
}

function getHeaderTitle(path: string, title: any) {
  const index = path.replace("/", "").toLowerCase();
  return title[toCamelCase(index)];
}

function toCamelCase(txt: string) {
  return txt
    .toLowerCase()
    .split("-")
    .map((el, index) => {
      if (index !== 0) {
        return el.charAt(0).toUpperCase() + el.slice(1);
      }
      return el;
    })
    .join("");
}
